import Base from './base'
import renderFields from './wifi.pug'

export default class Wifi extends Base
  @label: "無線網路"

  renderFields: renderFields
